module.exports = __webpack_public_path__ + "img/noprogram@2x.9d0b9093.png";